import { Component, Input, Renderer2, Output, EventEmitter } from '@angular/core';
import { YoutubeApiService } from './youtube.api.service';
import { YoutubePlayerService } from './youtube.player.service';
var YoutubeComponent = (function () {
    function YoutubeComponent(youtubeApi, youtubePlayer, renderer) {
        this.youtubeApi = youtubeApi;
        this.youtubePlayer = youtubePlayer;
        this.renderer = renderer;
        this.ready = new EventEmitter();
        this.change = new EventEmitter();
        this.youtubeApi.loadApi();
    }
    YoutubeComponent.prototype.ngAfterContentInit = function () {
		var todate = new Date();
        var elementId = 'playerId' + (todate.getTime() % 1000000);
		var elementContainer = this.renderer.selectRootElement('#playerElement');
		
        this.renderer.setAttribute(elementContainer, 'id', elementId);
        var config = {
            elementId: elementId,
            width: this.width,
            height: this.height,
            videoId: this.videoId,
			playerVars:{controls:0,autoplay:1,cc_lang_pref:"en",cc_load_policy:1},
            outputs: {
                ready: this.onReady.bind(this),
                change: this.onChange.bind(this)
            }
        };
		if(config.videoId=='en' ||config.videoId=='no' || config.videoId=='fil' ){
			if(config.videoId == 'no'){
				config.playerVars.cc_load_policy=0;
			}else{
				config.playerVars.cc_lang_pref=config.videoId;
			}
			config.videoId = '';
			this.videoId = '';
		}
		if(config.width == undefined) {
			config.width =window.innerWidth;
		}else{ // if config.width is defined, then do not autoplay the video
			config.playerVars.autoplay = 0;
		}
		if(config.height == undefined) config.height = window.innerHeight;
		console.log("YoutubePlayer config", config, elementId );
        this.youtubePlayer.initialise(config);
    };
    YoutubeComponent.prototype.onReady = function (player) {
		console.log("YoutubePlayer ready")
        this.ytPlayer = player;
        this.ytPlayer.loadVideoById(this.videoId);
        this.ready.emit(this.ytPlayer);
    };
    YoutubeComponent.prototype.onChange = function (event) {
        this.change.emit(event);
    };
	
	
    YoutubeComponent.decorators = [
        { type: Component, args: [{
                    selector: 'youtube-component',
                    template: '<div id="playerElement"></div>'
                },] },
    ];
    /** @nocollapse */
    YoutubeComponent.ctorParameters = function () { return [
        { type: YoutubeApiService, },
        { type: YoutubePlayerService, },
        { type: Renderer2, },
    ]; };
    YoutubeComponent.propDecorators = {
        "videoId": [{ type: Input },],
		"width": [{ type: Input },],
		"height": [{ type: Input },],
        "ready": [{ type: Output },],
        "change": [{ type: Output },],
    };
    return YoutubeComponent;
}());
export { YoutubeComponent };
//# sourceMappingURL=youtube.component.js.map